enum locales {
   ru = 'ru',
   az = 'az',
   default = 'ru'
}

export default locales
